import {
	Harpic,
	checkDocument,
	hasOwn,
	// cleanLSSimilarKey,
} from '../../customLib';
import { getSideNotifs } from '../../cred';

const getSideNotifsLR = () => {
	let sideNotifsLR = null;

	if (checkDocument()) {
		const localSideNotifsLR =
			window.localStorage.getItem('sideNotifs') || 1578252000; // sidebar notif genesis time

		if (localSideNotifsLR !== null) {
			try {
				sideNotifsLR = JSON.parse(
					Harpic(decodeURIComponent(localSideNotifsLR))
				);
			} catch (err) {
				console.log(err);
			}
		}

		// try {
		// 	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(num => {
		// 		kukeej.remove(`readNotifications${num}`);
		// 	});
		// } catch (err) {
		// 	console.log(err);
		// }
	}
	return sideNotifsLR;
};

const getUpdateHeaderLR = () => {
	let updateHeader = null;

	if (checkDocument()) {
		const localUpdateHeader =
			window.localStorage.getItem('headerUpdates') || 1578252000; // sidebar notif genesis time

		if (localUpdateHeader !== null) {
			try {
				updateHeader = JSON.parse(
					Harpic(decodeURIComponent(localUpdateHeader))
				);
			} catch (err) {
				console.log(err);
			}
		}

		// try {
		// 	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(num => {
		// 		kukeej.remove(`readNotifications${num}`);
		// 	});
		// } catch (err) {
		// 	console.log(err);
		// }
	}
	return updateHeader;
};

// const newAnnouncementKey = 'announcements~10-30-18';

export const initialSideNotifs = {
	headerUpdatesLastRead: getUpdateHeaderLR(),
	headerUpdates: undefined,
	sideNotifs: [],
	nextNotifsUpdate: undefined,
	sideNotifsCount: 0,
	sideNotifsLastRead: getSideNotifsLR(),
	sideNotificationsOpen: false,
	/**
	 * Announcements
	 */
	silentAnnouncement: true,
	// announcementModal: false,
	// newAnnouncement: [],
	// announcements: [],
	// activeAnnouncements: [],
};

const __setHeaderUpdatesLastRead = ({
	headerUpdates,
	headerUpdatesLastRead: headerUpdatesLRCurr,
}) => {
	let headerUpdatesLastRead = headerUpdatesLRCurr;

	if (checkDocument() && typeof headerUpdates === 'object') {
		if (hasOwn(headerUpdates, 'id')) {
			headerUpdatesLastRead = headerUpdates.id;
			window.localStorage.setItem('headerUpdates', headerUpdatesLastRead);
		}
	}
	return {
		headerUpdatesLastRead,
		headerUpdates: undefined,
	};
};

// const checkNewAnnouncement = activeAnnouncements => {
// 	let stuffs = activeAnnouncements;
// 	let silentAnnouncement = false;

// 	if (checkDocument()) {
// 		if (window.localStorage.getItem(newAnnouncementKey) !== null) {
// 			try {
// 				const localstuffs = JSON.parse(
// 					Harpic(
// 						decodeURIComponent(
// 							window.localStorage.getItem(newAnnouncementKey)
// 						)
// 					)
// 				);
// 				if (Math.max(...stuffs) === Math.max(...localstuffs)) {
// 					silentAnnouncement = true;
// 				}
// 				stuffs = activeAnnouncements.filter(
// 					stuff => localstuffs.indexOf(stuff) === -1
// 				);
// 			} catch (err) {
// 				console.log(err);
// 			}
// 		}
// 		cleanLSSimilarKey('announcements', newAnnouncementKey);
// 	}
// 	return {
// 		silentAnnouncement,
// 		newAnnouncement: stuffs,
// 	};
// };

// const __setNewAnnouncement = (
// 	{ newAnnouncement, activeAnnouncements },
// 	announcements
// ) => {
// 	if (newAnnouncement.indexOf(announcements) === -1) {
// 		return {
// 			newAnnouncement,
// 		};
// 	}

// 	const updatedNewAnnouncement = newAnnouncement.slice(0);
// 	updatedNewAnnouncement.splice(newAnnouncement.indexOf(announcements), 1);
// 	const localNewAnnouncement = activeAnnouncements.filter(
// 		stuff => updatedNewAnnouncement.indexOf(stuff) === -1
// 	);

// 	if (checkDocument()) {
// 		window.localStorage.setItem(
// 			newAnnouncementKey,
// 			encodeURIComponent(JSON.stringify(localNewAnnouncement))
// 		);
// 	}
// 	// console.log({ NewAnnouncement: updatedNewAnnouncement });
// 	return {
// 		newAnnouncement: updatedNewAnnouncement,
// 	};
// };

// const announcementModalSwitch = toggle => ({
// 	announcementModal: toggle,
// });

// export const announcementActions = {
// 	/**
// 	 * Check for New Announcements:
// 	 */

// 	// __setNewAnnouncement,
// 	__announcementModalOpen: () => announcementModalSwitch(true),
// 	__announcementModalClose: () => announcementModalSwitch(false),
// };

const __fetchSideNotifs = async () => {
	try {
		const { status, data } = await getSideNotifs();

		if (status === 1 && data.length > 0) {
			const sideNotifsLastRead = getSideNotifsLR() || 0;
			let sideNotifsCount = 0;
			const currentDate = Date.now() / 1000;
			let nextNotifsUpdate = null;
			const headerUpdatesLastRead = getUpdateHeaderLR();

			const validData = data.filter(({ startTime, endTime, on }) => {
				if (!!on && on !== 0 && on !== 1) {
					return false;
				}
				if (startTime && currentDate < startTime) {
					return false;
				}

				if (endTime && currentDate > endTime) {
					return false;
				}

				return true;
			});

			const nonAnnouncements = [];

			validData.forEach(el => {
				nonAnnouncements.push(el);
			});

			const sideNotifs = nonAnnouncements.filter(
				({ startTime, endTime, id }) => {
					if (
						startTime &&
						startTime > currentDate &&
						(startTime < nextNotifsUpdate || !nextNotifsUpdate)
					) {
						nextNotifsUpdate = startTime;
					}
					if (
						endTime &&
						endTime > currentDate &&
						(endTime < nextNotifsUpdate || !nextNotifsUpdate)
					) {
						nextNotifsUpdate = endTime;
					}

					if (id > sideNotifsLastRead) {
						sideNotifsCount += 1;
					}

					return true;
				}
			);

			const headerUpdates = sideNotifs.find(
				({ header, id }) =>
					header === 1 &&
					(headerUpdatesLastRead ? id > headerUpdatesLastRead : true)
			);

			return {
				sideNotifs,
				sideNotifsLastRead,
				sideNotifsCount,
				headerUpdates,
				nextNotifsUpdate,
				// announcements,
				// activeAnnouncements,
			};
		}
	} catch (error) {
		console.log('sideNotifs', error);
	}
	return {};
};

const __setNotificationRead = ({
	sideNotifs,
	sideNotifsLastRead: sideNotifsLRCurr,
}) => {
	let sideNotifsLastRead = sideNotifsLRCurr;

	if (checkDocument()) {
		if (
			Array.isArray(sideNotifs) &&
			sideNotifs.length > 0 &&
			hasOwn(sideNotifs[0], 'id')
		) {
			sideNotifsLastRead = sideNotifs[0].id;
			window.localStorage.setItem('sideNotifs', sideNotifsLastRead);
		}
	}
	return {
		sideNotifsCount: 0,
		sideNotifsLastRead,
	};
};

export const sidebarActions = {
	/**
	 * Check for new Sidebar Notifs
	 */
	__fetchSideNotifs,
	__setNotificationRead,
	__setHeaderUpdatesLastRead,
	__openSideNotifs: () => ({
		sideNotificationsOpen: true,
	}),
	__closeSideNotifs: () => ({
		sideNotificationsOpen: false,
	}),
	// ...announcementActions,
};
